var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-header"},[_c('button',{staticClass:"btn btn-close-card",on:{"click":_vm.close}},[_c('span',{staticClass:"ti-arrow-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }